<div class="router-hosting-config-container">
  @if (isModal) {
    <div class="title">{{ title }}</div>
  }
  <div class="subtitle" [innerHtml]="subtitle"></div>
  @if (isModal) {
    <div class="close cancel" (click)="cancel()"></div>
  }
  <div class="nf-hosted-config-row nf-hosted-config-grid-row">
    <div class="config-item">
      <div class="config-item-label-container">
        <span class="config-title">CLOUD PROVIDER</span>
        @if (!readonly) {
          <span class="config-label">REQUIRED</span>
        }
      </div>
      @if (canNFHost) {
        <select
          id="Provider"
          [(ngModel)]="svc.nfRouterData.provider"
          (change)="getRegions($event)"
          >
          @for (provider of providers | sortby: 'type':'asc'; track provider) {
            <option [value]="provider.type">
              {{ provider.type }}
            </option>
          }
        </select>
      }
      @if (!canNFHost) {
        <div class="config-container">
          <div class="config-container-label">
            {{ svc.nfRouterData.provider }}
          </div>
        </div>
      }
    </div>

    <div class="config-item">
      <div class="config-item-label-container">
        <span class="config-title">LOCATION</span>
        @if (!readonly) {
          <span class="config-label">REQUIRED</span>
        }
      </div>
      @if (svc.errors['region']) {
        <span class="error error-message">{{ svc.errors['region'] }}</span>
      }
      @if (canNFHost) {
        <select
          (change)="regionChanged()"
          [(ngModel)]="svc.nfRouterData.locationCode"
          [ngClass]="{ error: svc.errors['region'] }"
          id="Region"
          >
          <option [value]="undefined">Select a Datacenter</option>
          @for (region of displayedRegions | sortby: 'city':'asc'; track region) {
            <option [value]="region.locationCode">
              {{ region.city }} {{ region.locationCode }}
            </option>
          }
        </select>
      }
      @if (!canNFHost) {
        <div class="config-container">
          <div class="config-container-label">
            {{ svc.nfRouterData.region }}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="nf-hosted-config-row nf-hosted-config-grid-row">
    <div class="config-item">
      <div class="config-item-label-container">
        <span class="config-title">LINK LISTENER</span>
        @if (!readonly) {
          <span class="config-label">OPTIONAL</span>
        }
      </div>
      @if (!readonly) {
        <div class="config-container toggle-container">
          <div class="config-container-label">ENABLE LINK LISTENER</div>
          <div (click)="toggleLinkListener()" [ngClass]="{ on: svc.nfRouterData.linkListener }" class="toggle">
            <span [hidden]="!svc.nfRouterData.linkListener" class="on-label">YES</span>
            <span [hidden]="svc.nfRouterData.linkListener" class="off-label">NO</span>
            <div class="switch"></div>
          </div>
        </div>
      }
      @if (readonly) {
        <div class="config-container">
          <div class="config-container-label">
            {{ svc.nfRouterData.linkListener ? 'ENABLED' : 'DISABLED' }}
          </div>
        </div>
      }
    </div>
    <div class="config-item">
      <div class="config-item-label-container">
        <span class="config-title">WSS LISTENER</span>
        @if (!readonly) {
          <span class="config-label">OPTIONAL</span>
        }
      </div>
      @if (canNFHost) {
        <div class="config-container toggle-container">
          <div class="config-container-label">ENABLE WSS</div>
          <div
            (click)="toggleWSSListener()"
                    [ngClass]="{
                        on: svc.nfRouterData.wssListener,
                        disabled: readonly,
                        error: svc.errors['wssListener']
                    }"
            class="toggle"
            >
            <span [hidden]="!svc.nfRouterData.wssListener" class="on-label">YES</span>
            <span [hidden]="svc.nfRouterData.wssListener" class="off-label">NO</span>
            <div class="switch"></div>
          </div>
        </div>
      }
      @if (!canNFHost) {
        <div class="config-container">
          <div class="config-container-label">
            {{ svc.nfRouterData.wssListener ? 'ENABLED' : 'DISABLED' }}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="nf-hosted-config-column">
    @if (showAltDomainField) {
      <div class="config-item">
        <div class="config-item-label-container">
          <span class="config-title">{{
            svc.nfRouterData.id ? 'ADVERTISED NAME' : 'CUSTOM DNS - SET ADVERTISED NAME'
          }}</span>
          @if (!readonly) {
            <span class="config-label">OPTIONAL</span>
          }
        </div>
        @if (svc.errors['alternateDomainName']) {
          <span class="error error-message">{{
            svc.errors['alternateDomainName']
          }}</span>
        }
        @if (showAltDomainInput) {
          <input
            class="form-field-input"
            placeholder="uuid.mycompany.com"
            [(ngModel)]="svc.nfRouterData.alternateDomainName"
            [ngClass]="{ error: svc.errors['alternateDomainName'] }"
            (keyup)="altDomainChangedDebounced()"
            />
        }
        @if (showAltDomainLabel) {
          <div class="config-container">
            <div class="config-container-label domain-label">
              {{ svc.nfRouterData.alternateDomainName }}
            </div>
          </div>
        }
      </div>
    }
    @if (readonly && svc.nfRouterData.domainName) {
      <div class="config-item disabled">
        <div class="config-item-label-container">
          <span class="config-title">NETFOUNDRY DNS</span>
        </div>
        <div class="config-container">
          <div class="config-container-label domain-label">
            {{ svc.nfRouterData.domainName }}
          </div>
        </div>
      </div>
    }
  </div>
  <div class="nf-hosted-config-row config-row-end">
    @if (!readonly) {
      <div (click)="cancel()" class="linkButton cancel">
        {{ cancelAction }}
      </div>
    }
    @if (!readonly) {
      <button
        class="save confirm"
        id="SaveHostRouter"
        (click)="updateHosting()"
        [ngClass]="{ disabled: svc.hosting }"
        >
        {{ svc.hosting ? 'Updating' : readonly ? 'Edit Hosting' : 'Save' }}
        @if (svc.hosting) {
          <span class="spinner"></span>
        }
      </button>
    }
  </div>
</div>
